// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/agents/tasks/page"
import { usePageHead } from "../../../compat/head"

export const Route = createFileRoute("/agents/tasks/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Task Agents - PIC support" })
  return <Page />
}
